import { signalStore, withState } from '@ngrx/signals';
import { eventLogTypeCrud } from '../services/api/crud-ops/event-log-type.crud';
import { EventLogTypesService } from '../services/api/generated/event-log-types/event-log-types.service';
import { EventLogType } from '../types/event-log.interface';
import { GenericState, withCrudMethods } from './generic.store';
import { withById, withCaching } from './store.mixins';

const initialState: GenericState<EventLogType> = {
  entities: [],
  selectedId: null,
  cache: {},
  lastUpdated: 0,
};

export const EventLogTypeStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withState(initialState),
  withCrudMethods<EventLogType, EventLogTypesService>(EventLogTypesService, eventLogTypeCrud, 10 * 60 * 1000),
  withCaching<EventLogType>(10 * 60 * 1000),
  withById<EventLogType>(),
);
